module.exports = __webpack_public_path__ + "static/horea-8f8fefc5551613b42d663121c2e1acd5.jpg";